
export enum LayoutRoutes {
  Dashboard = "dashboard"
};
